export const OPT_IN_CONFIG = 'OPT_IN_CONFIG' as const;
export type OptInConfig = { variant: string; config: typeof OPT_IN_CONFIG };
